export default ".radio-group {\n  display: flex;\n  flex-direction: column;\n}"